'use strict';

var fonts = require('./fonts/fonts.js');

var xxxlarge = {
  fontFamily: fonts.base,
  fontSize: 31,
  fontWeight: 600,
  lineHeight: 1.35
};
var xxlarge = {
  fontFamily: fonts.base,
  fontSize: 26,
  fontWeight: 600,
  lineHeight: 1.23
};
var xlarge = {
  fontFamily: fonts.base,
  fontSize: 22,
  fontWeight: 600,
  lineHeight: 1.5
};
var large = {
  fontFamily: fonts.base,
  fontSize: 18,
  lineHeight: 1.5
};
var base = {
  fontFamily: fonts.base,
  fontSize: 15,
  lineHeight: 1.53
};
var small = {
  fontFamily: fonts.base,
  fontSize: 13,
  lineHeight: 1.54
};
var xsmall = {
  fontFamily: fonts.base,
  fontSize: 11,
  lineHeight: 1.55
};
var base$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  xxxlarge: xxxlarge,
  xxlarge: xxlarge,
  xlarge: xlarge,
  large: large,
  base: base,
  small: small,
  xsmall: xsmall
});
exports.base = base;
exports.base$1 = base$1;
exports.large = large;
exports.small = small;
exports.xlarge = xlarge;
exports.xsmall = xsmall;
exports.xxlarge = xxlarge;
exports.xxxlarge = xxxlarge;